
    <h2 mat-dialog-title style="font-family: 'Inter', sans-serif;
    font-size: 14px;
    text-align: justify;">{{ data }}</h2>
    <div mat-dialog-actions style="justify-content: center">
      <button type="button" class="btn btn-success" mat-button mat-dialog-close>OK</button>
    </div>
  